/** The Visit board's client-run bulk commands (queued actions come from metadata); the board's one handler routes by id. */
import { VisitBrowseRow } from '@jms/model';
import { Command } from '@workbuddy/ui/model';
import type { BulkCommandArgs, BulkCommandOutcome, EntityBoardBulkCommandsArgs } from '@workbuddy/ui/v2/blocks/entity.board/context';
import { runVisitRetryJobCreationBulk, VISIT_RETRY_JOB_CREATION_BULK_ID, visitRetryJobCreationBulkCommands } from './visit.retry.job.creation.command';

type VisitBulkHandler = (args: BulkCommandArgs<VisitBrowseRow>) => Promise<BulkCommandOutcome | false>;

const HANDLERS: Readonly<Record<string, VisitBulkHandler>> = {
  [VISIT_RETRY_JOB_CREATION_BULK_ID]: runVisitRetryJobCreationBulk,
};

export function visitBulkCommands(args: EntityBoardBulkCommandsArgs<VisitBrowseRow>): Command[] {

  return visitRetryJobCreationBulkCommands(args);
}

/** Unknown ids fall through, so metadata-provided bulk actions keep their default handling. */
export async function handleVisitBulkCommand(args: BulkCommandArgs<VisitBrowseRow>): Promise<BulkCommandOutcome | false> {

  return HANDLERS[args.action]?.(args) ?? false;
}
